export enum AvailabilityBreadcrumbSteps {
  productsModelsSelection = 'products-selection',
  productsQuantities = 'quantities',
}
